<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单记录
  -->
  <div class="pb50">
    <div class="product-content">
      <div class="table-wrap" style="margin-left:20px">
        <div class="common-form mt16">订单记录</div>
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in detail.orderLog" :key="index" :type='activity.type' 
            :timestamp="String(activity.time)" placement="top" class="max-w460">
            <el-card>
              <el-image v-if="activity.image" :src="activity.image" alt="暂无图片" :preview-src-list="[activity.image]"
                style="width: 100px; height: 100px">
              </el-image>
              <!-- :src=" 'data:image/png;base64,'  + item.image"    :src="activity.image" -->
              <!-- <img v-if="activity.image" style="width: 100px; height: 100px" :src="activity.image" class="icon" alt="暂无图片" /> -->
              <p>{{ activity.value }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { deepClone } from "@/utils/base.js";
export default {
  inject: ["detail"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      activities: []
    };
  },
  created() {
  },
  methods: {
    changetime(e) {
      var date = new Date(e * 1000); // 将秒数转换为毫秒
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1
      var day = date.getDate().toString().padStart(2, '0');
       
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return `${year}-${month}-${day}`+ ' ' + h + ':' + m + ':' + s;
     
    }
  }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/order/part/record.vue